import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { QueueViewModule } from 'components/queue-view/queue-view.module';
import { RecordingsModule } from 'components/recordings-list';
import { WorkLayoutModule } from 'components/work-layout/work-layout.module';
import { RootLayoutComponent } from 'components/root-layout/root-layout.component';
import { RootAuthGuard } from 'components/root-layout/root-auth-guard';
import { bcStates } from 'common/common/states';
import { QueueViewComponent } from 'components/queue-view/queue-view.component';
import { RecordingsComponent } from 'components/recordings-list/recordings.component';
import { WorkLayoutComponent } from 'components/work-layout/work-layout.component';
import { TranslateModule } from '@ngx-translate/core';
import { AuthGuard } from 'components/root-layout/auth-guard';

const rootRoutes: Routes = [
  {
    path: '',
    component: RootLayoutComponent,
    canActivate: [RootAuthGuard],
    children: [
      {
        path: '',
        canActivateChild: [AuthGuard],
        children: [
          { path: bcStates.layout.url, component: WorkLayoutComponent },
          { path: bcStates.queueView.url, component: QueueViewComponent },
          { path: bcStates.recordingsList.url, component: RecordingsComponent },
          { path: '', redirectTo: bcStates.layout.url, pathMatch: 'full' }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [
    TranslateModule,
    QueueViewModule,
    RecordingsModule,
    WorkLayoutModule,
    RouterModule.forChild(rootRoutes)
  ],
  declarations: [
    RootLayoutComponent
  ],
  exports: [
    RouterModule
  ]
})
export class RootLayoutModule {}
